<mat-radio-button
  [disabled]="disabled()"
  [color]="color()"
  [name]="name()"
  [value]="value"
  [checked]="value"
  (change)="changed($event.value)">
  {{ label() }}
</mat-radio-button>
